/* eslint-disable prettier/prettier */
import {
    bdayImg2,
    bdayImg3,
    djsetImg1,
    eventImg1,
    galleryImg5,
    galleryImg6,
    haldiImg2,
    mandapImg1,
    prImg1,
    ser1Img,
    stageImg4,
    wedImg2,
} from "../assests/images";

/* eslint-disable prettier/prettier */
const serviceList = [
    {
        id: "s1",
        name: "Home Decorations",
        desc: "With our experienced home décor services (flowers, decor, lights, and props), transform your home into a spectacular event location.",
        tag: "Home Decorations",
        link: "/gallery?items=home-decorations",
        image: galleryImg6,
    },
    {
        id: "s2",
        name: "Stage Decorations",
        desc: "We decorate the stage according to your concept and the objective of the event to reflect the host's personality and brand.",
        tag: "Stage Decorations",
        link: "/gallery?items=state-decorations",
        image: stageImg4,
    },
    {
        id: "s3",
        name: "Haldi Stage",
        desc: "Make your Haldi ceremony more joyful with decor elements, lighting effects, flowers. Capture this special moment of Haldi ceremony.",
        tag: "Haldi Stage",
        link: "/gallery?items=haldi-stage",
        image: haldiImg2,
    },
    {
        id: "s4",
        name: "Events Decorations",
        desc: "Our decoration based on your concept and the objective of the event to reflect the host's personality and brand.",
        tag: "Events Decorations",
        link: "/gallery?items=events-decorations",
        image: eventImg1,
    },
    {
        id: "s5",
        name: "Birthday Decorations",
        desc: "Customize the birthday celebrations with our decorations such as Balloons decorations , Surprised gift , specialized cake making.",
        tag: "Birthday Decorations",
        link: "/gallery?items=birthday-decorations",
        image: bdayImg3,
    },
    {
        id: "s6",
        name: "Mandap Decorations",
        desc: "House decor with flowers, febric, lights and props ....for wedding n all types of parties",
        tag: "Mandap Decorations",
        link: "/gallery?items=mandap-decorations",
        image: mandapImg1,
    },
    {
        id: "s7",
        name: "Balloons Decorations",
        desc: "Enhance your events/Venue with our special balloons decorations such as birthday celebrations,corporate parties and many more.",
        tag: "Balloons Decorations",
        link: "/gallery?items=balloons-theme-decorations",
        image: bdayImg2,
    },
    {
        id: "s8",
        name: "Palki Decorations",
        desc: "Set the traditional look of the wedding occasion by hiring the best palki decorators to design it fabulously.",
        tag: "Palki Decorations",
        link: "/gallery?items=palki-decorations",
        image: galleryImg5,
    },
    {
        id: "s9",
        name: "Wedding Decorations",
        desc: "House decor with flowers, febric, lights and props ....for wedding n all types of parties",
        tag: "Wedding Decorations",
        link: "",
        image: wedImg2,
    },

    {
        id: "s11",
        name: "Lights Decorations",
        desc: "Enhance your events/Venue with our Lights  decorations such as birthday,festival,wedding celebrations,corporate parties and many more.",
        tag: "Lights Decorations",
        link: "/gallery?items=lights-decorations",
        image: ser1Img,
    },
    {
        id: "s12",
        name: "Dj Setup & Lighting",
        desc: "We also arrange the full Dj setup and Dj lighting to make your moments more joyful",
        tag: "Dj Setup And Lighting",
        link: "/gallery?items=dj-setup-and-lighting",
        image: djsetImg1,
    },
    {
        id: "s13",
        name: "Personalized Gifts",
        desc: "We are also make special/Personalized gifts for your lover or specials ones.",
        tag: "Personalized Gifts",
        link: "/gallery?items=personalized-gifts",
        image: prImg1,
    },
    // {
    //     id: "s14",
    //     name: "Outside Birthday Planning",
    //     desc: "Plan your birthday celebrations Private place. we will decorate place as your demand with our Balloons decorations , Surprised gift, etc.",
    //     tag: "Outside Birthday Planning",
    //     link: "/gallery?items=outside-birthday-planning",
    //     image: ser1Img,
    // },
    // {
    //     id: "s15",
    //     name: "Full Stage Program",
    //     desc: "Full stage program is our services where we our all services are including like(Decorations, Lightings, Balloons decoration, Dj setup",
    //     tag: "Full Stage Program",
    //     link: "/gallery?items=full-stage-program",
    //     image: ser1Img,
    // },
];

export default serviceList;
